import {
  Component,
  ContentChild,
  EventEmitter,
  OnInit,
  Output,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-done-modal',
  templateUrl: './done-modal.component.html',
  styleUrls: ['./done-modal.component.scss'],
  standalone: true,
  imports: [NgTemplateOutlet],
  encapsulation: ViewEncapsulation.None
})
export class DoneModalComponent implements OnInit {
  @ContentChild('content') content: TemplateRef<any>;
  @Output() done = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  onClickDone() {
    this.done.emit();
  }
}
